(function () {
    'use strict';

    angular
        .module('adm')
        .config(AdmDepartmentRoute);

    AdmDepartmentRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function AdmDepartmentRoute ($stateProvider) {
        $stateProvider
            .state('root.adm.department', {
                abstract: true,
                url: '/department',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state('root.adm.department.list', {
                url:'/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/department/list/list.html',
                        controller: 'AdmDepartmentListController',
                        controllerAs: 'admDepartmentList'
                    }
                }
            })
            .state('root.adm.department.create', {
                url:'/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/adm/department/create/form.html',
                        controller: 'AdmDepartmentCreateController',
                        controllerAs: 'admDepartmentCreate'
                    }
                }
            });
    }
})();